import { MutableRefObject } from "react";

/**
 * Margin to avoid rounding issues in chrome.
 */
const chromeMargin = 10;
const sideNavigate = (
    navElement: MutableRefObject<HTMLElement | null>,
    direction: string,
    speed: number,
    distance: number,
    step: number
) => {
    const { current } = navElement;
    if (current) {
        let scrollAmount = 0;
        let previousScrollLeft = current.scrollLeft;

        const slideTimer = setInterval(() => {
            const maxScrollLeft = current.scrollWidth - current.clientWidth - chromeMargin;
            let newScrollLeft = current.scrollLeft;
            let shouldStop = false;

            if (direction === "left") {
                // Calculate new position but don't go below chromeMargin. Zero value does not work on chrome due to rounding issues
                newScrollLeft = Math.max(chromeMargin, current.scrollLeft - step);
                if (newScrollLeft === chromeMargin) shouldStop = true;
            } else {
                // Calculate new position but don't exceed maxScrollLeft
                newScrollLeft = Math.min(maxScrollLeft, current.scrollLeft + step);
                if (newScrollLeft >= maxScrollLeft) {
                    shouldStop = true;
                }
            }
            current.scrollLeft = newScrollLeft;

            // Check if scroll position actually changed
            if (previousScrollLeft === current.scrollLeft) {
                shouldStop = true;
            }
            previousScrollLeft = current.scrollLeft;

            scrollAmount += step;

            // Stop if we've reached distance or hit boundaries
            if (scrollAmount >= distance || shouldStop) {
                window.clearInterval(slideTimer);
            }
        }, speed);
    }
};

export default sideNavigate;
